export default __webpack_public_path__ + "static/media/codicon_pass.48f5bb57.svg";